import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DwLoggingService, DwRoutingService, DwRoutingServiceToken, DwSecurityStateService } from '@devwareapps/devware-cap';

@Injectable({
    providedIn: 'root'
})
export class AviatorRouteGuardService implements CanActivate {
    private readonly authEntryPaths = new Set(['login', 'register']);

    constructor(
        @Inject(DwRoutingServiceToken) private routingService: DwRoutingService,
        private securityStateService: DwSecurityStateService,
        private logutil: DwLoggingService,
    ) {
        

     }

    canActivate(routeSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const route = routeSnapshot.routeConfig;
        const routePath = route?.path;

        if (routePath && this.authEntryPaths.has(routePath)) {
            if (this.securityStateService.securityState.isAuthenticated) {

                this.routingService.navigateToUrl("/", null);

                return false;
            }
        }

        return true;
    }
}
